import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, switchMap, tap } from 'rxjs';


import {
  deleteService,
  editService,
  editServiceError,
  editServiceSuccess,
  loadService,
  loadServiceSuccess,
  saveService,
  saveServiceSuccess,
} from './service.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { IService } from 'src/app/shared/interfaces/service/service';
import { TaskService } from 'src/app/shared/services/task.service';

@Injectable()
export class ServiceEffects {
  constructor(
    private service: TaskService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadService$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadService),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadServiceSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveService$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveService),
      concatMap(({ service }) =>
        this.service.save(service).pipe(
          tap(() => this.notify.saveSuccess()),
          //tap((res) => {console.log(res)}),
          //tap(() => this.notify.saveSuccess()),p
          switchMap((res) => [saveServiceSuccess({ service: res }), loadService()]),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editService$ = createEffect(() =>
    this.action$.pipe(
      ofType(editService),
      concatMap(({ service, id }) =>
        this.service.edit(service, id).pipe(
          tap(() => this.notify.editSuccess()),
          switchMap((res: IService) => [loadService(), editServiceSuccess({service: res})]),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            editServiceError(error.error['hydra:description']);
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deleteService$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteService),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadService()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
